import { render, staticRenderFns } from "./ReserveWaitPopup.vue?vue&type=template&id=ff593cca&scoped=true&"
import script from "./ReserveWaitPopup.vue?vue&type=script&lang=js&"
export * from "./ReserveWaitPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReserveWaitPopup.vue?vue&type=style&index=0&id=ff593cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff593cca",
  null
  
)

export default component.exports